module.exports = __webpack_public_path__ + "static/media/position.349f79da.svg";